// extracted by mini-css-extract-plugin
export default {"update_answers_container":"UpdateAnswers_update_answers_container__XL-nw","update_answers_link":"UpdateAnswers_update_answers_link__I9Dbw"};